export let changeNoteColorMenuText = "VDDIt";
export default {changeNoteColorMenuText};